<div id="navbar-dropdown-container">
    <div id="navbar-hero">
        <div class='navbar-dropdown-submenu-container' [ngClass]="{'narrow' : dropdownType() == 'sectors', 'wide' : dropdownType() != 'sectors'}">
            @switch (dropdownType()) {
            @case ('sectors') {
            <div id="navbar-dropdown-sectors">
                <ul>
                    <li class="navbar-selector-box" (mouseenter)="changeSubmenu('public-security')">Seguridad pública</li>
                    <li class="navbar-selector-box" (mouseenter)="changeSubmenu('private-security')">Seguridad privada</li>
                    <li class="navbar-selector-box" (mouseenter)="changeSubmenu('inspections')">Inspecciones</li>
                </ul>
            </div>
            }
            @case ('products') {
            <div id="navbar-dropdown-products">
                <ul>
                    <li class="navbar-selector-box"><a href="/products/matrice-400">Matrice 400</a></li>
                    <li class="navbar-selector-box"><a href="/products/matrice-4">Matrice 4</a></li>
                    <li class="navbar-selector-box"><a href="/products/dock3">Dock 3</a></li>
                    <li class="navbar-selector-box"><a href="/products/matrice-4-td">Matrice 4 TD</a></li>
                    <li class="navbar-selector-box"><a href="/products/fh2">FlightHub 2</a></li>
                    <li class="navbar-selector-box"><a href="/products/terra">Terra</a></li>
                </ul>
            </div>
            }
            }
        </div>

    @if (dropdownType() == 'sectors') {
        <div id="navbar-dropdown-submenu-itemlist">
            @switch (itemListHovered) {
                @case ('public-security') {
                    <div class="row-container">
                        <div class="submenu-itemlist-content">
                            @for (section of publicSecurity.sections; track $index) {
                                <div class="col-container">
                                    <h2 class="submenu-itemlist-title">{{section.title}}</h2>
                                    @for (application of section.applications; track $index) {
                                        <div>
                                            <a [href]="'sectors/public-security/'+application.link">{{application.cardtitle}}</a>
                                        </div>
                                    }

                                </div>
                            }
                        </div>
                        <a href="/sectors/public-security">Más información sobre las soluciones de Seguridad pública <fa-icon icon="chevron-right"></fa-icon></a>
                    </div>
                }
                @case ('private-security') {
                    <div class="row-container">
                        <div class="submenu-itemlist-content">
                            @for (section of privateSecurity.sections; track $index) {
                                <div class="col-container">
                                    <h2 class="submenu-itemlist-title">{{section.title}}</h2>
                                    @for (application of section.applications; track $index) {
                                        <div>
                                            <a [href]="'sectors/private-security/' + application.link">{{application.cardtitle}}</a>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <a href="/sectors/private-security">Más información sobre las soluciones de Seguridad privada <fa-icon icon="chevron-right"></fa-icon></a>
                    </div>
                }
                @case ('inspections') {
                    <div class="row-container">
                        <div class="submenu-itemlist-content">
                            @for (section of inspections.sections; track $index) {
                                <div class="col-container">
                                    <h2 class="submenu-itemlist-title">{{section.title}}</h2>
                                    @for (application of section.applications; track $index) {
                                        <div>
                                            <a [href]="'sectors/inspections/' + application.link">{{application.cardtitle}}</a>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <a href="/sectors/inspections">Más información sobre las soluciones de Inspecciones <fa-icon icon="chevron-right"></fa-icon></a>
                    </div>
                }
            }
        </div>
    }

    </div>

</div>